// extracted by mini-css-extract-plugin
export default {"text":"styles_text__xIUqI","wrapper":"styles_wrapper__b3NwG","container":"styles_container__rOl8P","actions":"styles_actions__WAmbO"};